<div class="toolbar-container mct-flex-gt-sm mct-row-gt-sm mct-flex-lt-sm mct-col-lt-sm mct-justify-between mct-items-center mct-gap-5">
  <div class="p-inputgroup search-bar mct-flex mct-row mct-gap-0 input-group-btn atlas-autocomplete">
    <p-autocomplete
      placeholder="{{ 'shared.container.toolbars.module.revenue.search-text' | translate }}"
      optionLabel="display"
      emptyMessage="{{ 'common.phrases.no-results-found' | translate | ucfirst }}"
      [(ngModel)]="selectedResult"
      [suggestions]="searchResults"
      [minLength]="3"
      (completeMethod)="search($event)"
      (onSelect)="autocompleteInvoiceSelected($event)"
    >
      <ng-template let-result pTemplate="item">
        {{ result.display }}
      </ng-template>
    </p-autocomplete>
    <button pButton type="button" class="atlas-input-addon btn btn-default" icon="pi pi-times-circle" (click)="clear()"></button>
  </div>
  <div class="revenue-toolbar-buttons">
    <button
      pButton
      class="atlas-btn atlas-btn-secondary tall-36"
      [label]="'shared.container.toolbars.module.revenue.new-invoice' | translate | titlecase"
      icon="pi pi-plus"
      (click)="showNewInvoice = true"
    ></button>

    <button
      pButton
      class="atlas-btn atlas-btn-secondary tall-36"
      [label]="'shared.container.toolbars.module.revenue.new-payment' | translate | titlecase"
      icon="pi pi-plus"
      (click)="showNewPayment = true"
    ></button>
  </div>
</div>

<wl-new-invoice-dialog [(show)]="showNewInvoice"></wl-new-invoice-dialog>
<wl-batch-payment-dialog [(show)]="showNewPayment"></wl-batch-payment-dialog>
